<template>
  <el-select
    v-model="selected"
    :size="size"
    :multiple="multiple"
    :remote="autoLoad"
    :loading="loading"
    :clearable="clearable"
    :placeholder="placeholder"
    :value-key="valueField"
    @change="onChange"
    @clear="handleClear"
    :disabled="disabled"
  >
    <el-option
      v-for="item in list"
      :key="item.key"
      :label="item.value"
      :value="valueType === 'object' ? item.rawData : item.key"
    >
      <slot name="item" :item="item" />
    </el-option>

    <template v-if="pageable" #footer>
      <el-pagination
        @size-change="handlePageChange"
        @current-change="handlePageChange"
        :current-page="page"
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="total"
      />
    </template>
  </el-select>
</template>

<script>
import { SmartControlMixin } from "./SmartControlMixin";

export default {
  name: "SmartSelect",
  emits: ["select", "input", "change"],
  mixins: [SmartControlMixin],
  props: {
    disabled: { type: Boolean, default: false },
    clearable: { type: Boolean, default: true },
    placeholder: { type: String, default: "Please select" },
    size: { type: String, default: "default" },
    value: null, // 补充
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
      this.$emit("change", val);
      // 派发select事件，传递完整SmartItem
      let selectedItems = [];
      if (this.multiple) {
        selectedItems = (val || [])
          .map((v) => {
            if (this.valueType === "object") {
              return this.list.find((item) => item.rawData === v) || null;
            } else {
              return this.list.find((item) => item.key === v) || null;
            }
          })
          .filter(Boolean);
        this.$emit("select", selectedItems);
      } else {
        let selectedItem = null;
        if (this.valueType === "object") {
          selectedItem = this.list.find((item) => item.rawData === val) || null;
        } else {
          selectedItem = this.list.find((item) => item.key === val) || null;
        }
        this.$emit("select", selectedItem);
      }
    },
  },
  watch: {
    selected(val) {
      // v-model 双向绑定
      this.$emit("input", val);
    },
  },
};
</script>
